import { modals } from '@mantine/modals';
import type { WorkflowStepsAttributes } from 'api/models';

import { WorkflowTaskStepForm } from './WorkflowTaskStepForm';

type OpenWorkflowTaskStepModalOptions = {
  title: string;
  step?: WorkflowStepsAttributes;
  onSubmit: (step: WorkflowStepsAttributes) => void;
};

export const openWorkflowTaskStepModal = ({
  title,
  step,
  onSubmit,
}: OpenWorkflowTaskStepModalOptions) =>
  modals.open({
    title,
    size: 'xl',
    children: (
      <WorkflowTaskStepForm
        step={step}
        onSubmit={submittedStep => {
          onSubmit(submittedStep);
          modals.closeAll();
        }}
      />
    ),
  });
